import {
  CHIP_RADIUS_LG,
  CHIP_SOLID_SURFACE,
} from "../../constants/chipStyles";

/** Section header badge — solid purple border */
const SectionBadgeChip = ({
  children,
  className = "",
  style = {},
  textClassName = "whitespace-nowrap text-[12px] font-semibold uppercase tracking-[0.82px] text-[#7D3BEE]",
  textStyle = { fontFamily: '"Rethink Sans", sans-serif' },
}) => (
  <div
    className={`relative flex w-max max-w-full shrink-0 items-center justify-center ${CHIP_RADIUS_LG} ${CHIP_SOLID_SURFACE} px-[8.19px] ${className}`}
    style={{ height: "33px", ...style }}
  >
    <span className={textClassName} style={textStyle}>
      {children}
    </span>
  </div>
);

export default SectionBadgeChip;
